import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入router
import router from './router'
import store from './store'
//引入mock
import './api/mock'
import http from './utils/request';
Vue.prototype.$http = http;
// https://www.jmwd.asia
Vue.prototype.imageUrl = 'https://www.jmwd.asia'
Vue.config.productionTip = false
Vue.use(ElementUI);

// Vue.use(VueRouter)
new Vue({
  render: h => h(App),
  router, // 将 router 注入到根实例
  store,
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount('#app')
